import api from "../utils/axios/axiosConfig";

const rolesService = {
  create: (data) => api.post("/role/create", data),

  update: (id, data) => api.put(`/role/update/${id}`, data),

  delete: (id) => api.delete(`/role/delete/${id}`),

  search: (params) => api.post("/role/search", params),

  get: (id) => api.get(`/role/getOne/${id}`),
};

export default rolesService;
